module.exports = __webpack_public_path__ + "static/img/104913.b732842f.png";